import React from 'react';

import {

  TextField,

} from '@material-ui/core';

import { Search } from '@material-ui/icons';

import PropTypes from 'prop-types';

import fieldStyles from '../../styles/fieldStyles';
import { searchField } from '../../styles/formElementsStyles';

import translations from '../../languages/i18n';

export default function SearchField({ handleChange, value }) {
  const classesField = fieldStyles();
  const search = searchField();
  return (
    <div style={{ width: 425 }}>
      <TextField
        className={search.root}
        fullWidth
        label={translations['_search']}
        margin='normal'
        size='small'
        variant='outlined'
        InputProps={{ endAdornment: <Search className={classesField.iconSearch} /> }}
        value={value}
        onChange={(event) => handleChange(event.target.value)}
      />
    </div>
  );
}

// Indica i controla els props que se han de passar al component
SearchField.propTypes = {
  handleChange: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
};
